import React from 'react';

export function Separator() {
  return (
    <div className="login-form__separator"/>
  );
}
